// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-search {\n  padding: 5px 0;\n}\n.table-search .el-form-item .el-form-item__label {\n  width: 100px;\n}\n", ""]);
// Exports
module.exports = exports;
